import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

export function DataPoints({ list, keyPrefix }) {
  const FULL_WIDTH_SECTIONS = ['States Available:', 'State Available:'];

  return (
    <div className="data-points h-100">
      <Row className="pt-0_75 py-md-1 pe-md-1">
        {list.map(({ title, value }) => (
          <Col
            key={`${keyPrefix}-${title}`}
            tag="dl"
            className="mb-0_25"
            xs={FULL_WIDTH_SECTIONS.includes(title) ? 12 : 6}
            md={12}
          >
            <dt className="small">{title}</dt>
            <dd className="fw-bold">{value}</dd>
          </Col>
        ))}
      </Row>
    </div>
  );
}

DataPoints.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  keyPrefix: PropTypes.string.isRequired,
};
